// ════════════════════════════════════════════════════════════════════
// Colle Bagnoli — script di tema.
// Porting di Base.astro + index.astro (tilt bottiglia) del sito Astro.
// Differenze rispetto all'originale:
//  - niente tipi TypeScript (Shopify serve JS puro, senza build step);
//  - niente `astro:page-load`: su Shopify ogni pagina è un caricamento
//    completo, quindi init() gira una volta sola al DOMContentLoaded;
//  - si aggancia a `shopify:section:load` perché nell'editor del tema le
//    sezioni vengono ricostruite al volo e i riferimenti al DOM decadono.
// ════════════════════════════════════════════════════════════════════
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // riferimenti correnti
  var nav = null;
  var floatCta = null;
  var footerEl = null;
  var burger = null;
  var mobile = null;
  var io = null;
  var countIO = null;

  // ── nav scroll state ──
  var onScroll = function () {
    if (nav) nav.classList.toggle('scrolled', window.scrollY > 60);
  };
  addEventListener('scroll', onScroll, { passive: true });

  // ── drawer mobile ──
  var toggle = function (open) {
    if (burger) {
      burger.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', String(open));
    }
    if (mobile) {
      mobile.classList.toggle('open', open);
      mobile.setAttribute('aria-hidden', String(!open));
    }
    document.body.style.overflow = open ? 'hidden' : '';
  };
  addEventListener('keydown', function (e) {
    if (e.key === 'Escape') toggle(false);
  });

  // ── counter: numeri che salgono quando entrano in viewport ──
  var fmt = function (n) { return n.toLocaleString('it-IT'); };
  var runCount = function (el) {
    var to = Number(el.dataset.countTo || '0');
    var from = Number(el.dataset.countFrom || '0');
    var dur = Number(el.dataset.countDur || '1600');
    if (reduce) { el.textContent = fmt(to); return; }
    var t0 = performance.now();
    var tick = function (t) {
      var p = Math.min(1, (t - t0) / dur);
      var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      el.textContent = fmt(Math.round(from + (to - from) * eased));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  // ── sticky CTA (rAF-throttled) ──
  var fcTick = false;
  var onFc = function () {
    if (!floatCta || fcTick) return;
    fcTick = true;
    requestAnimationFrame(function () {
      var past = window.scrollY > window.innerHeight * 0.9;
      var nearFooter = footerEl
        ? footerEl.getBoundingClientRect().top < window.innerHeight + 60
        : false;
      if (floatCta) floatCta.classList.toggle('show', past && !nearFooter);
      fcTick = false;
    });
  };
  addEventListener('scroll', onFc, { passive: true });

  // ── rito d'ingresso (porting da sito-astro, #entrata) ──
  // Sequenza: le scritte laterali salgono per prime, poi "Colle Bagnoli"
  // lettera per lettera → pausa → tutto ridiscende → il velo cala verso
  // il basso (non si solleva più) e scopre l'hero.
  // Si salta con un gesto qualsiasi e non si ripresenta nella sessione.
  // La classe entrata-attiva/no-entrata la decide, PRIMA del primo disegno,
  // lo script inline in theme.liquid (già tiene conto di reduced-motion e
  // di sessionStorage): qui basta controllarla, non ridecidere da capo.
  var initEntrata = function () {
    var velo = document.getElementById('entrata');
    if (!velo || !document.documentElement.classList.contains('entrata-attiva')) return;
    if (velo.dataset.entrataBound) return;
    velo.dataset.entrataBound = '1';

    var chiuso = false;
    var sblocca = function () { document.documentElement.classList.remove('entrata-attiva'); };

    var chiudi = function () {
      if (chiuso) return;
      chiuso = true;
      try { sessionStorage.setItem('cb-entrata', '1'); } catch (e) { /* modalità privata */ }
      velo.classList.add('esce');                                    // il testo ridiscende
      setTimeout(function () { velo.classList.add('via'); }, 320);    // il velo cala
      setTimeout(function () { velo.remove(); sblocca(); }, 1100);    // via dal DOM
    };

    requestAnimationFrame(function () { velo.classList.add('in'); });
    // 2200ms: l'ultima lettera arriva a ~1,65s, resta ferma ~0,55s, poi esce.
    var auto = setTimeout(chiudi, 2200);
    ['click', 'wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      addEventListener(ev, function () { clearTimeout(auto); chiudi(); }, { once: true, passive: true });
    });
    // rete di sicurezza: se qualcosa va storto, la pagina non resta bloccata
    setTimeout(function () { if (!chiuso) { velo.remove(); sblocca(); } }, 5000);
  };

  // ── hero: intro GSAP + parallasse in uscita ──
  // Sfondo che si allarga in ingresso, titolo che entra parola per parola
  // (SplitText, lento e deliberato), poi lo scroll cue, e un leggero
  // parallasse quando si scorre oltre l'hero. Se GSAP non è caricato (solo
  // su template.name == 'index', vedi theme.liquid) o l'utente preferisce
  // meno movimento, tutto resta semplicemente visibile: niente classe
  // .anim-hero, niente opacity:0.
  var initHeroFull = function () {
    var heroEl = document.querySelector('.hero');
    var titleEl = document.getElementById('heroTitle');
    if (!heroEl || !titleEl || reduce || !window.gsap || !window.ScrollTrigger) return;
    if (heroEl.dataset.heroBound) return;
    heroEl.dataset.heroBound = '1';

    gsap.registerPlugin(ScrollTrigger);
    var hasSplit = false;
    try { gsap.registerPlugin(SplitText); hasSplit = true; } catch (e) {}

    document.documentElement.classList.add('anim-hero');

    var start = function () {
      var tl = gsap.timeline({ defaults: { ease: 'power4.out' } });
      tl.from('.hero-bg img', { scale: 1.15, duration: 2.4, ease: 'power2.out' }, 0);

      var wordsDone = 2.2; // punto della timeline in cui l'ultima parola è arrivata
      if (hasSplit) {
        try {
          var st = new SplitText(titleEl, { type: 'words', mask: 'words' });
          gsap.set(titleEl, { opacity: 1 });
          tl.from(st.words, { yPercent: 115, duration: 1.4, stagger: 0.22, ease: 'power3.out' }, 0.3);
          wordsDone = 0.3 + (st.words.length - 1) * 0.22 + 1.4;
        } catch (e) {
          gsap.set(titleEl, { opacity: 1 });
          tl.from(titleEl, { autoAlpha: 0, y: 30, duration: 1.2 }, 0.3);
          wordsDone = 1.5;
        }
      } else {
        gsap.set(titleEl, { opacity: 1 });
        tl.from(titleEl, { autoAlpha: 0, y: 30, duration: 1.2 }, 0.3);
        wordsDone = 1.5;
      }

      tl.to('.hero-bottle', { opacity: 1, duration: 1.4 }, 0.5)
        .to('.hero-scroll',  { opacity: 1, duration: .9 }, wordsDone - 0.3);

      gsap.to('.hero-bg img', {
        yPercent: 12, scale: 1.06, ease: 'none',
        scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true }
      });
      gsap.to('.hero-inner', {
        yPercent: -16, autoAlpha: 0, ease: 'none',
        scrollTrigger: { trigger: '.hero', start: '30% top', end: 'bottom top', scrub: true }
      });
      // La bottiglia non ha un fade in uscita: resta ferma (fluttua/tilt) e
      // viene semplicemente tagliata dal bordo dell'hero quando si scorre
      // oltre (.hero ha overflow:hidden), niente sparizione animata.
      ScrollTrigger.refresh();
    };

    // aspetta i font, altrimenti SplitText calcola le righe sui metrici sbagliati
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(start);
    } else {
      start();
    }
  };

  // ── tilt 3D della bottiglia hero (segue il mouse, solo desktop) ──
  // Il tilt scrive sempre translateY(-50%) come base (il CSS la usa per
  // centrare verticalmente .hero-bottle): senza, ogni movimento del mouse
  // la farebbe saltare in alto. Il float (heroFloat) resta sull'img, quindi
  // nessun conflitto con questo transform sul contenitore.
  var fine = matchMedia('(pointer: fine)').matches;
  var tiltHero = null;
  var bottle = null;
  var targetX = 0, targetY = 0, curX = 0, curY = 0;
  var rafOn = false;

  var loop = function () {
    if (!bottle) { rafOn = false; return; }
    curX += (targetX - curX) * 0.08;
    curY += (targetY - curY) * 0.08;
    bottle.style.transform = 'translateY(-50%) rotateY(' + curX + 'deg) rotateX(' + curY + 'deg)';
    if (Math.abs(targetX - curX) < 0.01 && Math.abs(targetY - curY) < 0.01 && targetX === 0 && targetY === 0) {
      rafOn = false; return;
    }
    requestAnimationFrame(loop);
  };
  var kick = function () { if (!rafOn) { rafOn = true; requestAnimationFrame(loop); } };

  var onMove = function (e) {
    if (!tiltHero) return;
    var r = tiltHero.getBoundingClientRect();
    var px = (e.clientX - r.left) / r.width - 0.5;   // -0.5 … 0.5
    var py = (e.clientY - r.top) / r.height - 0.5;
    targetX = px * 10;   // rotateY max ±5°
    targetY = -py * 7;   // rotateX max ±3.5°
    kick();
  };
  var onLeave = function () { targetX = 0; targetY = 0; kick(); };

  var initTilt = function () {
    if (!fine || reduce) return;
    tiltHero = document.querySelector('.hero');
    bottle = document.querySelector('.hero-bottle');
    if (tiltHero && bottle && !tiltHero.dataset.tiltBound) {
      tiltHero.dataset.tiltBound = '1';
      tiltHero.addEventListener('mousemove', onMove, { passive: true });
      tiltHero.addEventListener('mouseleave', onLeave);
    }
  };

  // ── sezione "cultivar Itrana" (blocco AI olive): la foto cresce a schermo
  // intero restando fissa mentre si scorre, poi il testo appare con calma.
  // Solo desktop (matchMedia 981px, come le altre animazioni dell'hero) e
  // solo se GSAP/ScrollTrigger sono caricati (solo template.name == 'index',
  // vedi theme.liquid). La crescita è legata allo scroll (scrub); il testo
  // no: parte una volta sola, con la sua durata, quando la crescita finisce.
  var initOliveHero = function () {
    var el = document.querySelector('.itrana-scroll');
    var content = document.querySelector('.itrana-scroll-content');
    var desktop = matchMedia('(min-width: 981px)').matches;
    if (!el || !content || !desktop || reduce || !window.gsap || !window.ScrollTrigger) return;
    if (el.dataset.oliveBound) return;
    el.dataset.oliveBound = '1';

    document.documentElement.classList.add('anim-olive-hero');
    gsap.set(content, { y: 20 });

    var revealed = false;
    var revealContent = function () {
      if (revealed) return;
      revealed = true;
      gsap.to(content, { opacity: 1, y: 0, duration: 1.6, ease: 'power2.out' });
    };

    gsap.timeline({
      scrollTrigger: {
        trigger: el, start: 'top 75%', end: '+=70%',
        scrub: 0.6, pin: true, anticipatePin: 1,
        onLeave: revealContent
      }
    }).to(el, { scale: 1, borderRadius: 0, ease: 'none' });

    ScrollTrigger.refresh();
  };

  // ── cronostoria (da la-nostra-storia.astro) ──
  // I pallini si accendono e la spina oro si riempie allo scroll.
  var tl = null;
  var tlSteps = [];
  var tlProg = null;

  var updateTimeline = function () {
    if (!tl) return;
    var trigger = window.innerHeight * 0.6;
    var tlTop = tl.getBoundingClientRect().top;
    var lastY = null;
    tlSteps.forEach(function (s) {
      var r = s.getBoundingClientRect();
      var dotY = r.top + r.height / 2;
      var on = dotY < trigger;
      s.classList.toggle('active', on);
      if (on) lastY = dotY;
    });
    if (tlProg) tlProg.style.height = lastY === null ? '0px' : Math.max(0, lastY - tlTop - 10) + 'px';
  };
  addEventListener('scroll', updateTimeline, { passive: true });
  addEventListener('resize', updateTimeline);

  var initTimeline = function () {
    tl = document.getElementById('storyTimeline');
    tlSteps = tl ? Array.prototype.slice.call(tl.querySelectorAll('.story-step')) : [];
    tlProg = tl ? tl.querySelector('.story-prog') : null;
    updateTimeline();
  };

  // ── showcase design (da design-bottiglia.astro) ──
  // Righe statiche, sempre visibili: resta solo il clic su un'immagine per
  // aprirla a schermo intero (lightbox).
  var closeLightbox = function () {
    var lb = document.getElementById('lightbox');
    if (lb) lb.classList.remove('open');
    document.body.style.overflow = '';
  };
  addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });

  var initShowcase = function () {
    var lb = document.getElementById('lightbox');
    var lbImg = lb ? lb.querySelector('img') : null;
    if (!lb || !lbImg) return;
    document.querySelectorAll('#designShowcase .ds-row-visual img').forEach(function (img) {
      if (img.dataset.bound) return;
      img.dataset.bound = '1';
      img.addEventListener('click', function () {
        lbImg.src = img.currentSrc || img.src;
        lbImg.alt = img.alt;
        lb.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
    });
    if (!lb.dataset.bound) {
      lb.dataset.bound = '1';
      lb.addEventListener('click', closeLightbox);
    }
  };

  // ── blob "Memoria" (da territorio-sonnino-agro-pontino.astro) ──
  // Un blob organico segue il cursore con inerzia e rivela la versione calda
  // della foto storica. La scia (blob più piccoli che inseguono) si allunga
  // con la velocità del mouse.
  var blobFine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var fig = null;
  var layer = null;
  var blobRaf = 0;
  var tx = 0, ty = 0, lastX = 0, lastY = 0, vel = 0, blobActive = false;
  // testa + 4 punti di scia, ognuno insegue il precedente (effetto gommoso)
  var pts = [{x:0,y:0},{x:0,y:0},{x:0,y:0},{x:0,y:0},{x:0,y:0}];
  var RADII = [110, 64, 44, 28, 16];

  var lerp = function (a, b, t) { return a + (b - a) * t; };

  var blobFrame = function () {
    if (!layer) { blobRaf = 0; return; }
    pts[0].x = lerp(pts[0].x, tx, 0.25);
    pts[0].y = lerp(pts[0].y, ty, 0.25);
    for (var i = 1; i < pts.length; i++) {
      pts[i].x = lerp(pts[i].x, pts[i - 1].x, 0.3);
      pts[i].y = lerp(pts[i].y, pts[i - 1].y, 0.3);
    }
    vel *= 0.9; // decadimento: da fermo la scia rientra sotto la testa
    var boost = Math.min(vel / 30, 1);
    var mask = pts.map(function (p, i) {
      var r = i === 0 ? RADII[0] : RADII[i] * (0.3 + 0.7 * boost);
      return 'radial-gradient(circle ' + r.toFixed(0) + 'px at ' + p.x.toFixed(1) + 'px ' + p.y.toFixed(1) + 'px, #000 55%, transparent 96%)';
    }).join(',');
    layer.style.setProperty('-webkit-mask-image', mask);
    layer.style.setProperty('mask-image', mask);
    var settled = Math.abs(pts[0].x - tx) < 0.3 && Math.abs(pts[0].y - ty) < 0.3;
    if (blobActive || !settled) blobRaf = requestAnimationFrame(blobFrame);
    else blobRaf = 0;
  };

  var onBlobMove = function (e) {
    if (!fig) return;
    var r = fig.getBoundingClientRect();
    tx = e.clientX - r.left;
    ty = e.clientY - r.top;
    vel += Math.hypot(e.clientX - lastX, e.clientY - lastY);
    lastX = e.clientX; lastY = e.clientY;
    // micro-parallax: l'immagine rivelata slitta appena in direzione opposta
    fig.style.setProperty('--pxx', ((tx / r.width - 0.5) * -6).toFixed(1) + 'px');
    fig.style.setProperty('--pyy', ((ty / r.height - 0.5) * -4).toFixed(1) + 'px');
    if (!blobRaf) blobRaf = requestAnimationFrame(blobFrame);
  };

  var initBlob = function () {
    fig = document.getElementById('memoriaBlob');
    layer = fig ? fig.querySelector('.th-reveal') : null;
    if (!fig || !layer || !blobFine || reduce || fig.dataset.bound) return;
    fig.dataset.bound = '1';
    fig.addEventListener('pointerenter', function (e) {
      blobActive = true;
      fig.classList.add('on', 'seen');
      var r = fig.getBoundingClientRect();
      tx = e.clientX - r.left; ty = e.clientY - r.top;
      pts.forEach(function (p) { p.x = tx; p.y = ty; });
      lastX = e.clientX; lastY = e.clientY; vel = 0;
      if (!blobRaf) blobRaf = requestAnimationFrame(blobFrame);
    });
    fig.addEventListener('pointermove', onBlobMove);
    fig.addEventListener('pointerleave', function () {
      blobActive = false;
      fig.classList.remove('on');
    });
  };

  // ── rito di degustazione (da olio-monocultivar-itrana.astro) ──
  // Gli step si illuminano allo scroll, la linea oro si riempie fino a quello
  // raggiunto. Stessa logica della cronostoria, ma su bullet verticali.
  var ritual = null;
  var ritualSteps = [];
  var ritualProg = null;

  var updateRitual = function () {
    if (!ritual) return;
    var trigger = window.innerHeight * 0.62; // linea di attivazione
    var contTop = ritual.getBoundingClientRect().top;
    var lastDot = null;
    ritualSteps.forEach(function (s) {
      var dot = s.querySelector('.drv-dot');
      if (!dot) return;
      var dotMid = dot.getBoundingClientRect().top + dot.offsetHeight / 2;
      var on = dotMid < trigger;
      s.classList.toggle('active', on);
      if (on) lastDot = dot;
    });
    if (ritualProg) {
      if (!lastDot) ritualProg.style.height = '0px';
      else {
        var dotMid2 = lastDot.getBoundingClientRect().top + lastDot.offsetHeight / 2;
        ritualProg.style.height = Math.max(0, dotMid2 - contTop - 16) + 'px';
      }
    }
  };
  addEventListener('scroll', updateRitual, { passive: true });
  addEventListener('resize', updateRitual);

  var initRitual = function () {
    ritual = document.getElementById('degustaRitual');
    ritualSteps = ritual ? Array.prototype.slice.call(ritual.querySelectorAll('.drv-step')) : [];
    ritualProg = ritual ? ritual.querySelector('.drv-prog') : null;
    updateRitual();
  };

  // ── barra progresso lettura (da Guide.astro) ──
  var bar = null;
  var barTick = false;
  var onScrollProgress = function () {
    if (!bar || barTick) return;
    barTick = true;
    requestAnimationFrame(function () {
      var total = document.documentElement.scrollHeight - window.innerHeight;
      var p = total > 0 ? Math.min(1, window.scrollY / total) : 0;
      if (bar) bar.style.width = p * 100 + '%';
      barTick = false;
    });
  };
  addEventListener('scroll', onScrollProgress, { passive: true });

  var initProgress = function () {
    bar = document.getElementById('readProgressBar');
    onScrollProgress();
  };

  // ── galleria prodotto (da product-main.liquid) ──
  // Clic su una miniatura mostra l'immagine corrispondente: nessuna immagine
  // viene rimossa dal DOM (resta nel markup per i motori di ricerca), cambia
  // solo quale ha la classe .on.
  var initProductGallery = function () {
    var gallery = document.getElementById('productGallery');
    if (!gallery || gallery.dataset.bound) return;
    var thumbsWrap = gallery.parentElement ? gallery.parentElement.querySelector('.product-thumbs') : null;
    if (!thumbsWrap) return;
    gallery.dataset.bound = '1';
    thumbsWrap.querySelectorAll('.pt-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.dataset.mediaId;
        gallery.querySelectorAll('.pg-img').forEach(function (img) {
          img.classList.toggle('on', img.dataset.mediaId === id);
        });
        thumbsWrap.querySelectorAll('.pt-thumb').forEach(function (t) { t.classList.toggle('on', t === thumb); });
      });
    });
  };

  // ── selezione varianti (da product-main.liquid) ──
  // Le "pillole" (.po-value) sono la UI; il <select> nascosto resta la fonte
  // di verità per il modulo (nome "id" richiesto da Shopify per /cart/add).
  // Cliccando una pillola si ricalcola la combinazione scelta su tutte le
  // opzioni e si cerca la variante che corrisponde su TUTTE, non solo
  // sull'ultima cliccata.
  var initVariantPicker = function () {
    var form = document.getElementById('productForm');
    if (!form || form.dataset.bound) return;
    var select = form.querySelector('#productVariantId');
    var priceBox = document.getElementById('productPrice');
    var submitBtn = document.getElementById('productSubmit');
    if (!select || !priceBox || !submitBtn) return;
    form.dataset.bound = '1';

    // barra add-to-cart fissa su mobile: rispecchia prezzo e disponibilità
    var stickyPrice = document.getElementById('stickyPrice');
    var stickyBtn = document.getElementById('stickyBtn');
    if (stickyBtn && !stickyBtn.dataset.bound) {
      stickyBtn.dataset.bound = '1';
      stickyBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    var optionGroups = Array.prototype.slice.call(form.querySelectorAll('.product-option'));
    var selected = optionGroups.map(function (group) {
      var on = group.querySelector('.po-value.on');
      return on ? on.dataset.value : null;
    });

    var applyVariant = function (option) {
      priceBox.innerHTML =
        (option.dataset.comparePrice && option.dataset.comparePrice !== option.dataset.price
          ? '<span class="pp-compare">' + option.dataset.comparePrice + '</span>' : '') +
        '<span class="pp-current">' + option.dataset.price + '</span>';
      var available = option.dataset.available === 'true';
      submitBtn.disabled = !available;
      select.value = option.value;
      if (stickyPrice) stickyPrice.textContent = option.dataset.price;
      if (stickyBtn) stickyBtn.disabled = !available;
    };

    var findMatch = function () {
      var options = Array.prototype.slice.call(select.options);
      var match = options.find(function (opt) {
        return selected.every(function (val, i) {
          return val === null || opt.dataset['option' + (i + 1)] === val;
        });
      });
      if (match) applyVariant(match);
    };

    optionGroups.forEach(function (group, i) {
      group.querySelectorAll('.po-value').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.po-value').forEach(function (b) { b.classList.remove('on'); });
          btn.classList.add('on');
          selected[i] = btn.dataset.value;
          findMatch();
        });
      });
    });

    // la barra sticky compare quando il bottone principale esce dallo schermo
    var stickyAtc = document.getElementById('stickyAtc');
    if (stickyAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        stickyAtc.classList.toggle('show', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -10% 0px' }).observe(submitBtn);
    }
  };

  // ── init: aggancia tutto al DOM corrente ──
  var init = function () {
    initEntrata();

    nav = document.getElementById('nav');
    floatCta = document.getElementById('floatCta');
    footerEl = document.querySelector('footer');
    onScroll(); onFc();

    // reveal on scroll (sipario incluso)
    if (io) io.disconnect();
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          if (io) io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal, .reveal-img, .hills-divider').forEach(function (el) {
      if (io) io.observe(el);
    });

    if (countIO) countIO.disconnect();
    countIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { runCount(e.target); if (countIO) countIO.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    document.querySelectorAll('[data-count-to]').forEach(function (el) {
      if (countIO) countIO.observe(el);
    });

    initHeroFull();
    initTilt();
    initOliveHero();
    initTimeline();
    initShowcase();
    initBlob();
    initRitual();
    initProgress();
    initProductGallery();
    initVariantPicker();

    // drawer: la guardia evita il doppio bind
    burger = document.getElementById('burger');
    mobile = document.getElementById('mobileMenu');
    if (burger && !burger.dataset.bound) {
      burger.dataset.bound = '1';
      burger.addEventListener('click', function () {
        toggle(burger.getAttribute('aria-expanded') !== 'true');
      });
      if (mobile) {
        mobile.querySelectorAll('a').forEach(function (a) {
          a.addEventListener('click', function () { toggle(false); });
        });
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // l'editor del tema ricostruisce le sezioni: ri-agganciamo i riferimenti
  document.addEventListener('shopify:section:load', init);
})();
